import { render, staticRenderFns } from "./book-with-a-specialist.vue?vue&type=template&id=09ca5730&scoped=true"
import script from "./book-with-a-specialist.vue?vue&type=script&lang=js"
export * from "./book-with-a-specialist.vue?vue&type=script&lang=js"
import style0 from "./book-with-a-specialist.vue?vue&type=style&index=0&id=09ca5730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca5730",
  null
  
)

export default component.exports